<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-typewriter icon"></i>
        Publiposts
      </h1>
      <a href="https://i7.network/planos/" target="_blank">
        <PrimaryButton class="px-5" icon="fa-solid fa-solid fa-plus">Novo</PrimaryButton>
      </a>
    </div>
  </div>

  <div class="align p-4 space_title">

    <div v-if="!loading || publiposts.data.length" class="card">
      <div class="table_container">
        <table class="table_responsive">
          <thead>
          <tr>
            <th>ID</th>
            <th>Título</th>
            <th>Plano</th>
            <th>Status</th>
            <th>Data da compra</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(publipost, key) in publiposts.data" :key="key">
            <td>
              {{ publipost.id }}
            </td>
            <td>
              {{ publipost.title }}
            </td>
            <td>
              <i class="fa-solid fa-globe icon_label me-1"></i>

              {{ publipost.type }}
            </td>
            <td class="text-nowrap">
              <i class="fa-solid fa-tag icon_label me-1"></i>
              <span class="badge" :style="'background-color: ' + publipost.status_color">{{ publipost.status_name }}</span>
            </td>
            <td class="text-nowrap">
              <i class="fa-solid fa-calendar-days icon_label me-1"></i>
              {{ $dateFormat(publipost.created_at) }}
            </td>
            <td class="actions">
              <router-link v-if="publipost.status == 'refused' || publipost.status == 'available'" :to="{ name: 'publipostEdit', params: { id: publipost.id }}">
                <button class="btn btn-secondary btn_action_responsive">
                  <span>Editar</span>
                  <i class="fa-regular fa-edit"></i>
                </button>
              </router-link>
              <a v-else-if="publipost.status == 'publish'" :href="publipost.url" target="_blank">
                <button class="btn btn-secondary btn_action_responsive" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-animation="true" data-bs-html="true" v-tooltip title="Acessar notícia">
                  <span>Acessar notícia</span>
                  <i class="fa-regular fa-link"></i>
                </button>
              </a>
            </td>
          </tr>

          <tr class="no_result" v-if="!publiposts || (publiposts.data && !publiposts.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="publiposts.meta.links" />

  </div>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import { onBeforeMount, onMounted, ref, watch } from 'vue';
import { usePublipostStore } from '@/stores/PublipostStore'
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useSiteStore } from '@/stores/SiteStore'
import axios from 'axios';

const loader = inject('$loader');
const loading = ref(false);
let cancelTokenSource = null;

const publipostStore = usePublipostStore();
const { publiposts, filter } = storeToRefs(publipostStore);

const siteStore = useSiteStore();
const sites = ref([]);

const route = useRoute();

onBeforeMount(() => {
  filter.value = {
    search: null,
    status: null,
    site: null,
  };

  if (route.query.search) {
    filter.value.search = route.query.search;
  }

  if (route.query.status) {
    filter.value.status = route.query.status;
  }

  if (route.query.site) {
    filter.value.site = route.query.site;
  }

  loadPubliposts();
});

onMounted(async() => {
  await siteStore.getSitesList();
  sites.value = siteStore.sites;
  sites.value.unshift({id: null, name: 'Todos os sites'});
});

watch(() => route.query.page, (newPage, oldPage) => {
  if (newPage !== oldPage) {
    window.scrollTo(0, 0);
    loadPubliposts();
  }
});

async function loadPubliposts() {
  loader.show();
  loading.value = true;
  filter.value.page = route.query.page ? parseInt(route.query.page) : null;

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  await publipostStore.getPubliposts(cancelTokenSource);

  loader.hide();
  loading.value = false;
}
</script>